import React from 'react';
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import * as _ from 'lodash';
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
// login/auth styles: imported in the main bundle on purpose - LoginView is a
// lazy chunk and rendering it before its async CSS arrives breaks the page
// on first client-side navigation (fine after refresh)
import './containers/base.less';

import NavRouter from './navigation/NavRouter'
import { InitializeApp } from './utils/initializeApp'
import { CLEAR_STORE } from './actions/types';

const onBeforeLift = (store) => {
  // PersistGate delays the rendering of your app's UI until your persisted state has been retrieved and saved to redux store
  // Use this callback to take some action before the gate lifts
  console.log('After this persistGate will lift...')

  let isNewStore = !_.get(store.getState(), 'general.newStoreValuev11072019', false)
  console.log('IS_NEW_STORE: ', isNewStore)
  if (isNewStore) {
    // Clear all reducers
    store.dispatch({ type: CLEAR_STORE })
  }
}


const { store, persistor } = InitializeApp()

function App() {
  return (
    <Provider store={store}>
      <PersistGate
        persistor={persistor}
        loading={null}
        onBeforeLift={() => onBeforeLift(store)}
        debug>
        <NavRouter />
        {/* <ToastContainer
          position='top-right'
          autoClose={5000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnHover
          style={{ marginTop: 40 }}
        /> */}
      </PersistGate>
    </Provider >
  );
}

export default App;
